module.exports = __webpack_public_path__ + "img/goi-nho.c9947e39.svg";